// modifer: styles/jss/nextjs-material-kit-pro/pages/aboutUsStyle.js
import { page, main } from 'styles/jss/original/base';

const styles = {
  page,
  main
};

export default styles;
